import React, { FC } from 'react';

import { TableCell, TableRow } from '@material-ui/core';

import { ScoreType } from '../../../../../../../../../../../store/admin/eventFormats/store';

import { useAssignResultsState } from '../../../../../../../../Common/AssignResults/Context/AssignResults.context';
import { ISkinsTableRow } from '../SkinsTableRow';

interface IProps extends ISkinsTableRow {
  onRowClick: (rowIndex: number) => () => void;
}

const SkinsTableTiedCollapsedRow: FC<IProps> = props => {
  const { hole, index, onRowClick } = props;

  const { selectedCombination, skinsResults } = useAssignResultsState();

  return selectedCombination ? (
    <TableRow
      id={`clickableRowResult-${index}`}
      key={`tableRowResult-${index}`}
      onClick={onRowClick(index)}
      className="results-table-table-body-row"
    >
      <TableCell className="index">{Number(hole) + 1}</TableCell>

      <TableCell className="playerName">{`${
        skinsResults[Number(hole)].length
      } players tied`}</TableCell>

      <TableCell className="result">
        {
          skinsResults[Number(hole)][0][
            ScoreType[selectedCombination.scoreType].toLowerCase() as 'gross' | 'net'
          ]
        }
      </TableCell>

      <TableCell />
    </TableRow>
  ) : (
    <></>
  );
};

export default SkinsTableTiedCollapsedRow;
